import gql from 'graphql-tag'

export const GET_NPS_SCORE = gql`
    query NpsScore {
        nps {
            score
        }
    }
`